<h2 mat-dialog-title>Colors:</h2>
<div class="w-100 m-0 p-2">

  <div class="row">
    <div style="font-size: 12px;" class="col-md-2 p-1 col-sm-2 col-2">Time</div>
    <div style="font-size: 12px;" class="col-md-2 p-1 col-sm-2 col-2">Color</div>
  </div>
    <ng-container *ngFor="let rowitem of colorRamp">
      <div class="row pt-1 pb-0">
        <div class="col-md-4 p-1 col-sm-2 col-2">
         {{rowitem.time}} min
        </div>
        <div class="col-md-4 p-1 col-sm-2 col-2">
          <input
          style="padding:0"
            class="w-100"
            type="color"
            [value]="rowitem.color"
            (ngModel)="(rowitem.color)"
            (change)="colorUpdate($event, rowitem.time)"
          />
        </div>
      </div>
    </ng-container>
    <div class="row">
      <div class="col-md-6"> <button  mat-button (click)="onDismiss()">Cancel</button></div>
      <div class="col-md-6" ><button  mat-raised-button (click)="update()" [color]="'glb_greenbtn'" >Update</button></div>


    </div>
</div>
